export enum StatusAddress {
  Found = 'Found',
  NotFound = 'NotFound',
}

export interface ValidAddress {
  status: StatusAddress.Found;
  rawAddress: string;
  address: string;
  lat: number;
  lng: number;
}

export interface InvalidAddress {
  status: StatusAddress.NotFound;
  rawAddress: string;
  address: null;
}

export type BatchAddress = ValidAddress | InvalidAddress;
